import React from 'react';
import {StorageMeter} from './storage-summary/storage-meter';
import {WorkspaceSelector} from '@common/workspace/workspace-selector';
import {RootFolderPage} from '../../drive-page/drive-page';
import {SidebarMenu} from './sidebar-menu';
import {useNavigate} from '@common/utils/hooks/use-navigate';
import {CreateNewButton} from '../create-new-button';
import {Button} from '@common/ui/buttons/button';
import {Link} from 'react-router-dom';
import {Trans} from '@common/i18n/trans';
import {useAuth} from '@common/auth/use-auth';
import {useLogout} from '@common/auth/requests/logout';
import clsx from 'clsx';
import {useSettings} from '@common/core/settings/use-settings';
import { useToggleSidebar } from '@app/contexts/toggleSidebar';

interface SidebarProps {
  className?: string;
}
export function Sidebar({className}: SidebarProps) {
  const {isSubscribed} = useAuth();
  const {billing} = useSettings();
  // console.log(billing.enable,11111);
  const {isdarkMode, setIsDarkMode} = useToggleSidebar()
  const logout = useLogout();
  return (
    <div
      className={clsx(
        className,
        `text-sm text-muted font-medium  flex flex-col gap-20 menu overflow-scroll pb-[8.5rem] mt-16 ${isdarkMode?"bg-[#202124]":"bg-[#006cb6]"}`
      )}
    >
      <div className="flex-auto ">
        <SidebarMenu />
        <StorageMeter />
        {billing.enable && (
          <div className="pl-40">
            <Button
              elementType={Link}
              // to={isSubscribed ? '/billing/change-plan' : '/pricing'}
              to={'/pricing'}
              variant="outline"
              color="primary"
              size="xs"
              className="btn-upgrade-new"
            >
              <Trans message="Upgrade" />
            </Button>
          </div>
        )}
        {/* <Link onClick={() => {
          logout.mutate();
        }} data-menu-item-id="4e6cie" className="block whitespace-nowrap flex items-center justify-start gap-10 h-40 w-full my-4 px-1 rounded-menu font-bt text-white hover:bg-hover outline-none focus-visible:ring-2 logout-icon" to="/drive/starred"><svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" data-testid="ExitToAppOutlinedIcon" className="svg-icon icon-md logout" height="1em" width="1em"><path d="M10.09 15.59 11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"></path></svg> <Trans message="Logout" /></Link> */}
      </div>
      <WorkspaceSwitcher />
    </div>
  );
}

function WorkspaceSwitcher() {
  const navigate = useNavigate();
  return (
    <WorkspaceSelector
      onChange={() => {
        navigate(RootFolderPage.path);
      }}
      className="w-full px-24 py-18 border-t flex-shrink-0 mt-auto"
    />
  );
}
